import { useEffect } from "react";
import { ProjetoDimensionadoOffGrid } from "src/components/projetos/dimensionados_offgrid";
import { appStore } from "src/framework/store/AppStore";

const PAGE_TITLE = "Projeto dimensionado offgrid";

const ProjetosOffGridDimensionadosPage = () => {
  useEffect(() => {
    appStore.setPageTitle(PAGE_TITLE);
    return () => {
      appStore.setPageTitle("");
    }
  }, [])

  return (
    <div className="container">
      <div className="row">
        <div className="X12">
          <ProjetoDimensionadoOffGrid />
        </div>
      </div>
    </div>
  );
};

export { ProjetosOffGridDimensionadosPage };
